import collections from "./genericProducts.json";

/**
 * Constant list of generic reagents & supplies (medicines are separate).
 * Branded products save only the numeric `id` here as `pgid`.
 * Append new items at the end with the next id; never reuse or renumber ids.
 */
/**
 * reusable:
 * - false: used per test (syringe, tube, test kit, reagent) -> declared upon dispensing, brand required.
 *          Reagents use uom "test"; the brand states how many tests per unit.
 * - true:  P.O. + monthly dispense by the Chief MLS (tourniquet, ballpen, PPE, QC, bulk liquids)
 *          -> never declared per patient.
 */
// retired generics stay in the file (ids are referenced) but are no longer offered
const active = collections.filter(({ retired }) => !retired);

// categories kept in the reagent inventory; every other category is a supply
const REAGENT_CATEGORIES = [
  "Reagent",
  "Test Kit",
  "Control",
  "Calibrator",
  "Stain",
  "Culture Media",
];

const GenericProducts = {
  isReagent: (pk) =>
    REAGENT_CATEGORIES.includes(
      collections.find(({ id }) => id === Number(pk))?.category,
    ),
  // every generic, including retired ones; use for lookups of saved ids
  collections,
  // generics that can still be selected
  active,
  // generics that can be tagged to a service and declared per patient
  perTest: active.filter(({ reusable }) => !reusable),
  isReusable: (pk) =>
    !!collections.find(({ id }) => id === Number(pk))?.reusable,
  find: (pk) => collections.find(({ id }) => id === Number(pk)),

  getName: function (pk) {
    return this.find(pk)?.name || `No name found for: ${pk}`;
  },
  getAbbr: function (pk) {
    return this.find(pk)?.abbreviation || `No abbr found for: ${pk}`;
  },

  whereIn: (cluster = []) =>
    collections.filter(({ id }) => cluster.map(Number).includes(id)),

  search: (keyword = "") => {
    const key = keyword.trim().toLowerCase();
    if (!key) return [];
    return active.filter(
      ({ name = "", abbreviation = "", subname = "", category = "" }) =>
        [name, abbreviation, subname, category].some((value) =>
          value.toLowerCase().includes(key)
        )
    );
  },
};

export default GenericProducts;
